import React from 'react'


const Contact = () => <div style={{margin: 180}}><h1>Contact</h1></div>

export default Contact

